import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Dialog from 'Components/UI/Dialog';
import useMobileLayout from 'Hooks/useMobileLayout';
import { closeModalWithAdditionalKeys } from 'Helpers/ModalHelper';
import DialogContainer from './DialogContainer';

const styles = () => ({
  root: {},
  dialogPaper: {},
});

const OutOfOfficeDialog = ({
  classes,
  isOpen,
  ...rest
}) => {
  const isMobile = useMobileLayout();

  return (
    <Dialog
      className={classes.root}
      classes={{
        paper: !isMobile && classes.dialogPaper,
        ...classes,
      }}
      fullScreen={isMobile}
      onClose={() => {
        closeModalWithAdditionalKeys(['outOfOfficeSelfLink']);
      }}
      open={isOpen}
      maxWidth="lg"
    >
      <DialogContainer
        closeModal={() => {
          closeModalWithAdditionalKeys(['outOfOfficeSelfLink']);
        }}
        {...rest}
      />
    </Dialog>
  );
};

OutOfOfficeDialog.defaultProps = {
  isOpen: true,
};

OutOfOfficeDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool,
  onSuccess: PropTypes.func.isRequired,
};

export default withStyles(styles)(OutOfOfficeDialog);
